import { useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { WIDTH_720 } from 'components/common/Slideout';
import SlideoutWithRouter from 'components/common/SlideoutWithRouter';
import NutritionFactsPanel from 'components/mealDetails/nutritionFacts/NutritionFactsPanel';

const NutritionalFactsSlideout = ({ closeSlideout, meal, showSlideout }) => {
  const transitionRef = useRef();

  return (
    <SlideoutWithRouter
      id="nutrition-facts-container-modal"
      labelId="nutrition-facts-label"
      show={showSlideout}
      desktopWidth={WIDTH_720}
      closeCallback={closeSlideout}
    >
      <TransitionGroup className="crossfadeContainer">
        {meal && (
          <CSSTransition timeout={200} className="fadeInOut" nodeRef={transitionRef}>
            <div ref={transitionRef}>
              <NutritionFactsPanel meal={meal} />
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </SlideoutWithRouter>
  );
};

NutritionalFactsSlideout.propTypes = {
  closeSlideout: PropTypes.func.isRequired,
  meal: PropTypes.object,
  showSlideout: PropTypes.bool.isRequired,
};

export default NutritionalFactsSlideout;
